import {
  GET_HORSE_RACE_COUPON_DETAIL_REQUEST,
  GET_HORSE_RACE_COUPON_DETAIL_SUCCESS,
  GET_HORSE_RACE_COUPON_DETAIL_FAILURE,
  GET_HORSE_RACE_COUPON_PRIZE_REQUEST,
  GET_HORSE_RACE_COUPON_PRIZE_SUCCESS,
  GET_HORSE_RACE_COUPON_PRIZE_FAILURE
} from 'Store/constants';
  
const initialState = {
  data: [],
  raceResults: [],
  isLoading: false,
  error: null
};
  
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HORSE_RACE_COUPON_DETAIL_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACE_COUPON_DETAIL_SUCCESS:
      return {
        data: action.payload,
        isLoading: false,
        error: null
      };
    case GET_HORSE_RACE_COUPON_DETAIL_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    
    case GET_HORSE_RACE_COUPON_PRIZE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_HORSE_RACE_COUPON_PRIZE_SUCCESS:
      return { ...state, raceResults: action.payload, isLoading: false, error: null
      };
    case GET_HORSE_RACE_COUPON_PRIZE_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
  